<script>
import {
  formatAdvancedBRL,
  formatBRLAbbreviated
} from "@/helpers/formatBRLAbbreviated";
import { isNil } from "lodash";
import moment from "moment";

export default {
  props: {
    label: String,
    type: {
      type: String,
      default: "currency"
    },
    value: [String, Number, Date]
  },
  computed: {
    hoveredValue() {
      if (isNil(this.value) || this.type !== "currency") {
        return "";
      }

      return formatAdvancedBRL(this.value);
    },
    isText() {
      return this.type === "text";
    },
    parsedValue() {
      if (isNil(this.value)) {
        return "";
      }

      if (this.type === "currency") {
        return formatBRLAbbreviated(this.value);
      }

      if (this.type === "number") {
        return new Intl.NumberFormat("pt-BR").format(this.value);
      }

      if (this.type === "date") {
        const date = moment(this.value);
        return date.format("DD/MM/YYYY");
      }

      return this.value;
    }
  },
  methods: {
    isNil
  }
};
</script>

<template>
  <v-card :class="{ 'text-start': isText }">
    <v-card-title v-if="label">{{ label }}</v-card-title>
    <v-card-text>
      <v-tooltip v-if="!isText && !isNil(value)" :disabled="!hoveredValue" top>
        <template #activator="{ on }">
          <span class="value" v-on="on">{{ parsedValue }}</span>
        </template>

        {{ hoveredValue }}
      </v-tooltip>
      <p v-else>{{ parsedValue }}</p>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
.v-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 125px;
  position: relative;
  text-align: center;

  .value {
    font-size: 1.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
  }

  .v-card__text {
    flex-grow: 1;
  }

  .v-card__title {
    display: block;
    font-size: 1rem;
    width: 100%;
    word-break: normal !important;
  }
}
</style>
